import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { Box } from '@mui/material';

function Layout({ children }) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh', // Garantiza que ocupe toda la altura de la ventana
            }}
        >
            <Navbar />
            <Box
                component="main"
                sx={{
                    flex: 1, // Expande el contenido para ocupar el espacio disponible
                    mt: 8, // Espacio bajo el AppBar
                }}
            >
                {children}
            </Box>
            <Footer />
        </Box>
    );
}

export default Layout;